import { Auth } from "aws-amplify";
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { createContext } from "react";
import { User } from "./typings/UserType";

interface IContextProps {
  setUser: Dispatch<SetStateAction<null>>;
  user: User | null;
}

const UserContext = createContext({
  setUser: () => {},
  user: null,
} as IContextProps);

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used inside UserProvider");
  } else return context;
};

export const UserProvider = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const [user, setUser] = useState(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
